'use client';
import React from 'react';

const SMS_NUMBER = '16474500681';

const services = [
  { name: 'Exterior Wash', price: '$49' },
  { name: 'Basic Interior Detail', price: '$99' },
  { name: 'Full Basic Detail', price: '$149' },
  { name: 'Premium Package', price: '$199' },
];

function openSMS(serviceName?: string) {
  const body = serviceName
    ? `Hi! I'd like to book a ${serviceName} appointment.`
    : 'Hi! I would like to book a car detail appointment.';
  const link = document.createElement('a');
  link.href = `sms:${SMS_NUMBER}?body=${encodeURIComponent(body)}`;
  link.setAttribute('target', '_self');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export default function BookingSection() {
  return (
    <section id="booking" className="py-24 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-xs font-800 uppercase tracking-widest text-blue-400 mb-3">Book your detail</p>
          <h2 className="font-fraunces text-4xl md:text-5xl text-white mb-3">
            Three steps.<br />
            <span className="italic font-light" style={{ color: '#60A5FA' }}>GET SHOWROOM SHINE</span>
          </h2>
          <p className="text-white/50 text-sm font-medium max-w-md mx-auto">
            Tap a service below and your text app will open — just send the message and we&apos;ll confirm your slot.
          </p>
        </div>

        <div className="bento-card glass-tile p-8 md:p-10 flex flex-col gap-4">
          {/* Steps */}
          <div className="flex items-center justify-center gap-4 mb-6">
            {['Pick a service', 'Text us', 'We confirm'].map((label, i) => (
              <React.Fragment key={label}>
                <div className="flex flex-col items-center gap-2">
                  <div className="w-9 h-9 rounded-full bg-blue-500/20 border border-blue-400/30 flex items-center justify-center text-blue-300 text-sm font-800">
                    {i + 1}
                  </div>
                  <span className="text-xs font-600 text-white/50 text-center">{label}</span>
                </div>
                {i < 2 && <div className="flex-1 h-px bg-white/10 mb-4" />}
              </React.Fragment>
            ))}
          </div>

          {/* Service buttons */}
          <div className="grid grid-cols-1 gap-3">
            {services.map((svc) => (
              <button
                key={svc.name}
                onClick={() => openSMS(svc.name)}
                className="flex items-center justify-between w-full px-5 py-4 rounded-2xl bg-white/5 border border-white/10 hover:bg-blue-500/15 hover:border-blue-400/40 transition-all duration-200 group"
              >
                <div className="flex items-center gap-3">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-blue-400">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                  </svg>
                  <span className="text-white font-600 text-sm">{svc.name}</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-blue-300 font-700 text-sm">{svc.price}</span>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-white/30 group-hover:text-blue-400 transition-colors">
                    <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
                  </svg>
                </div>
              </button>
            ))}
          </div>

          {/* General book button */}
          <button
            onClick={() => openSMS()}
            className="btn-mint w-full py-4 rounded-2xl font-700 text-sm mt-2"
          >
            Book My Appointment →
          </button>

          <p className="text-center text-white/30 text-xs font-500 mt-1">
            Opens your text app · Text{' '}
            <a href={`sms:${SMS_NUMBER}`} className="text-blue-400 hover:text-blue-300 transition-colors">
              +1 (647) 450-0681
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}